<!-- Job Details header section -->
<div>
  <div class="row" *ngIf="isProjectDetailsEvaluationCriteriaTab">
    <div class="col my-2">
      <div class="d-flex justify-content-between align-items-center">

        <div>
          <p class="f-14 font-weight-500 mb-1"><span class="position-relative mr-2">Screen<span
                class="ai-text">AI</span></span>Evaluation Criteria</p>
          <p class="f-12 font-weight-400 mb-0">Select from AI-suggested criteria or add your own to define how candidates
            should be
            assessed.</p>
        </div>

        <div>
          <div class="text-webbtree-green pointer" *ngIf="!editMode && !showProgressBar && jobDetails?.data?.source == 'create'"
            (click)="enableEditMode('edit')" style="border: 1px solid #2E93A1; padding: 4px 21px 4px 7px;">
            <i class="fa-regular fa-pen-to-square"></i>
            <span class="ml-1">Edit Criteria</span>
          </div>
        
          <span [matTooltip]="availableIntegrations?.length ? '' : 'Please connect your ATS'"
            [matTooltipDisabled]="!!availableIntegrations?.length" matTooltipClass="red-tooltip text-black">
            <div class="text-webbtree-green pointer"
              *ngIf="!editMode && !showProgressBar && jobDetails?.data?.source == 'import'"
              (click)="availableIntegrations?.length && enableEditMode('edit')"
              [class.cursor-not-allowed]="!availableIntegrations?.length"
              style="border: 1px solid #2E93A1; padding: 4px 21px 4px 7px;">
              <i class="fa-regular fa-pen-to-square"></i>
              <span class="ml-1">Edit Criteria</span>
            </div>
          </span>
        </div>

        <div class="text-webbtree-green pointer" *ngIf="editMode" (click)="enableEditMode('close')"
          style="border: 1px solid #2E93A1; padding: 4px 11px 4px 10px;">
          <i class="fa-regular fa-xmark"></i>
          <span class="ml-1">Close</span>
        </div>

      </div>
    </div>
  </div>
</div>

<div class="">
  <div class="row">
    <div class="col">
      <div class=""  *ngIf="!isProjectDetailsEvaluationCriteriaTab">
          <p class="f-14 font-weight-500 mb-1"><span class="position-relative mr-2">Screen<span
                class="ai-text">AI</span></span>Evaluation Criteria</p>
          <p class="f-14 font-weight-400">Select from AI-suggested criteria or add your own to define how candidates
            should be
            assessed.</p>
        </div>
      <div style="border: 1px solid #D5DEE6; padding: 10px; border-bottom: 0;">
        <div class="expert-badge">
          <div>
            <i class="fa-solid fa-lightbulb-on"></i>
          </div>
          <div>
            <p><span class="font-weight-600" style="color: #128ff7;">Pro Tip:</span> Use this structure for clearer,
              more effective evaluation criteria.</p>
            <p class="text-black">Candidate who have <span style="color: #000; font-style: italic;">[ATTRIBUTE /
                BEHAVIOR / EXPERIENCE]</span> in/with/from <span style="color: #000; font-style: italic;">[CONTEXT /
                SCOPE / EXAMPLES]</span><br>
              <span style="font-style: italic;">e.g: Candidate who have experience leading cross-functional teams in
                fast-paced environments</span>
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>


<div class="row">
  <div class="col">
    <div style="border: 1px solid #D5DEE6; padding: 10px;">
      <!-- Top Priority -->
      <div *ngIf="formLength().length > 1" class="mb-2">
        <span class="gradient-text">
          <i class="fa-regular fa-angle-up"></i> (High Priority)
        </span>
      </div>

      <!-- Evaluation Criteria Form -->
      <div [formGroup]="aiScreeningMasterForm">
        <div cdkDropList [cdkDropListDisabled]="!editMode && isProjectDetailsEvaluationCriteriaTab"
          (cdkDropListDropped)="onDrop($event)" class="d-flex flex-column gap-3">

          <div *ngFor="let key of formLength(); let idx = index" [formGroupName]="key" cdkDrag
            [cdkDragDisabled]="!editMode && isProjectDetailsEvaluationCriteriaTab" class="criteria-drag-container">

            <div *ngIf="!isProjectDetailsEvaluationCriteriaTab || (editMode && isProjectDetailsEvaluationCriteriaTab)">
              <span class="mr-2 cursor-move">
                <i class="fa-solid fa-grip-vertical f-20 text-9696"></i>
              </span>
            </div>

            <div class="ai-criteria-card">
              <div class="d-flex justify-content-between mb-3">
                <div class="w-75 d-flex align-items-center">
                  <p class="text-truncate mb-0 font-weight-500">Criteria {{ idx + 1 }}</p>
                </div>


                <div class="text-right pointer"
                  *ngIf="(editMode || !isProjectDetailsEvaluationCriteriaTab) && formLength().length > 1">
                  <span (click)="deleteCriteria(key)">
                    <i class="far fa-trash f-14" style="color: #EC221F;"></i>
                  </span>
                </div>
              </div>

              <div>
                <span *ngIf="!editMode && isProjectDetailsEvaluationCriteriaTab">
                  {{ aiScreeningMasterForm.get([key, 'question'])?.value | titlecase}}
                </span>

                <input data-testid="auto-app-screening-criteria-input-1" *ngIf="editMode || !isProjectDetailsEvaluationCriteriaTab" formControlName="question" type="text"
                  class="wc-form-control" placeholder="Enter Screenᴬᴵ Evaluation Criteria" />
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Low Priority -->
      <div *ngIf="formLength().length > 1" class="mb-2">
        <span class="gradient-text">
          <i class="fa-regular fa-angle-down"></i>(Low Priority)
        </span>
      </div>

      <!-- Evaluation Criteria AI Suggession -->
      <div class="ai-chip-container"
        *ngIf="formLength().length < 5 && ((!isProjectDetailsEvaluationCriteriaTab) || (isProjectDetailsEvaluationCriteriaTab && editMode))">
        <span *ngFor="let c of SUGGESTED_CRITERIA | slice:0:5">
          <ng-container *ngIf="!c.selected">
            <p class="ai-screening-chips" (click)="useGivenCriteria(c)">
              <span class="gedient-criteria">
              <i class="fa-solid fa-plus mr-2"></i>
              <span>{{c.suggestion_content}}</span>
              </span>
            </p>
          </ng-container>
        </span>
      </div>

    </div>

    <!-- Add More Evaluation Criteria -->
    <div
      *ngIf="(formLength().length < 5 && !isProjectDetailsEvaluationCriteriaTab) || (formLength().length < 5 && isProjectDetailsEvaluationCriteriaTab && editMode)"
      class="text-center mb-3" (click)="addNewCriteria()">
      <button data-testid="auto-app-screening-criteria-button-1" class="btn-trms-small mt-6 criteria-btn" [disabled]="showAddCriteriaSpinner">
        <span [ngClass]="{ 'spinner-border text-white spinner-size': showAddCriteriaSpinner }"
          [ngStyle]="{ 'width: 20px; height: 20px;': showAddCriteriaSpinner }">
          {{showAddCriteriaSpinner ? '' : '+ Add More Criteria'}}
        </span>
      </button>
    </div>

    <!-- Save Evaluation Criteria -->
    <div class="text-right mt-6"
      *ngIf="(isProjectDetailsEvaluationCriteriaTab && editMode) || !isProjectDetailsEvaluationCriteriaTab">
      <button data-testid="auto-app-screening-criteria-button-2" class="btn-trms-medium mb-6"
        (click)="isProjectDetailsEvaluationCriteriaTab ? openEditEvaluationCriteriaModel() : submitChanges()"
        [disabled]="showExploreCandidateSpinner">
        <span [ngClass]="{ 'spinner-border text-white spinner-size': showExploreCandidateSpinner }"
          [ngStyle]="{ 'width: 20px; height: 20px;': showExploreCandidateSpinner }">
          {{showExploreCandidateSpinner ? '' : isProjectDetailsEvaluationCriteriaTab ? 'Save Changes' : 'Continue'}}
        </span>
      </button>
    </div>

  </div>
</div>


<!-- For Open Edit Evaluation model -->
<ng-template #editEvaluationCriteria class="modal">
  <div class="modal-content p-3">
    <div>
      <span class="f-14 font-weight-600 d-flex">
        <i class="fa-solid fa-info-circle mr-2" style="color:#FFED27"></i>
        <span>
        Are you sure you want to update  <span class="position-relative mr-3">Screen<span class="ai-text" style="font-size: 12px; right:-12px;">AI</span></span> evaluation criteria?</span></span>
    </div>
    <div class="d-flex flex-column w-100 mt-2 border-gray-2 mb-3">
      <p class="font-weight-500">Changing your evaluation criteria will:</p>
      <p class="d-flex"><i class="fa-light fa-circle-1 mr-2" style="margin-top: 3px;"></i> <span>Re-run ScreenAI for all {{jobDetails?.candidatesCount}} existing candidates, updating their scores and AI summaries.</span></p>
      <p class="mb-0 d-flex"><i class="fa-light fa-circle-2 mr-2" style="margin-top: 3px;"></i> <span>Pause new candidate sync until re-evaluation is finished.</span></p>
      <hr class="my-4 w-100" style="border-top: 1px solid #d9d9d9; height: 2px;">
      <span class="font-weight-500">This process may take a few minutes.</span>
    </div>

    <div class="row mt-1">
      <div class="col text-right">
        <button data-testid="auto-app-screening-criteria-button-3" class="btn-trms-white mr-3" (click)="dismiss()">Cancel</button>

        <button data-testid="auto-app-screening-criteria-button-4" class="btn-trms-small" [ngClass]="{ 'text-center': showExploreCandidateSpinner }"
          (click)="submitChanges()" [disabled]="showExploreCandidateSpinner">
          <span [ngClass]="{ 'spinner-border spinner-size': showExploreCandidateSpinner }"
            [ngStyle]="{ 'width: 20px; height: 20px;': showExploreCandidateSpinner }">
            {{showExploreCandidateSpinner ? '' : 'Confirm & Re-run'}}
          </span>
        </button>
      </div>
    </div>
  </div>
</ng-template>

<!-- For import jobs model -->
<ng-template #jobCreatedSuccessfullModel class="modal">
  <div class="modal-content p-3">
    <div class="col mb-3 px-0">
      <span class="d-flex" (click)="closeJobCreatedModel()">
        <i class="fa-solid fa-xmark f-16 ml-auto pointer"></i>
      </span>
    </div>
    <div class="mb-4">
      <div class="text-center mx-auto mb-3" style="width: 75px; height: 75px; border-radius: 50%; overflow: hidden;">
        <i class="fa-solid fa-check-circle" style="color: #6EDBA4; font-size: 70px;"></i>
      </div>
      <p class="f-14 font-weight-600 text-center mb-2" *ngIf="jobDetails?.calledfrom == 'job-create'">Job Created Successfully</p>
      <p class="f-14 font-weight-400 text-center mb-3" *ngIf="jobDetails?.calledfrom == 'job-create'">You can now upload candidates and start AI evaluation.</p>

      <p class="f-14 font-weight-600 text-center mb-2" *ngIf="jobDetails?.calledfrom != 'job-create'">Job Imported Successfully</p>
      <p class="f-14 font-weight-400 text-center mb-3" *ngIf="jobDetails?.calledfrom != 'job-create'"> <span class="position-relative mr-3">Screen<span class="ai-text" style="font-size: 12px !important; top: -2px; right: -10px;">AI</span></span>is setting things up for you.</p>
    </div>
  </div>
  <div class="progress-container">
    <div class="progress-bar" [style.width.%]="progress">
    </div>
  </div>
</ng-template>


<ngb-alert class="ngb-alert" *ngIf="successMessage" type="success" (close)="successMessage = ''">
  <span class="successCheck"><i class="fal fa-check"></i> </span>
  <span class="successmsg">{{ successMessage }}</span>
</ngb-alert>

<ngb-alert class="ngb-alert" *ngIf="errorMessage" type="danger" (close)="errorMessage = ''">
  <span class="errorCheck"><i class="fal fa-times"></i></span>
  <span class="errormsg"> {{ errorMessage }} </span>
</ngb-alert>

<ngb-alert class="ngb-alert" style="background-color: yellow !important;" *ngIf="infoMessage" type="info"
  (close)="infoMessage = ''">
  <span class="infoCheck"><i class="fal fa-info-circle"></i></span>
  <span class="infomsg ml-1">{{ infoMessage }}</span>
</ngb-alert>
